import { RatePlanMerged } from "@/helpers/interfaces/RatePlanMerged.ts";
import { RateGroup } from "@/helpers/types/types.ts";

export type ParentRatePlanMap = Record<string, RatePlanMerged>;

/**
 * Function to create a single ratePlan with children if they exist (paid per person)
 * @param rateGroup
 */
export const mergeRatePlans = (rateGroup: RateGroup): RatePlanMerged[] => {
  // Map to store parent rate plans by their IDs
  const parentRatePlansMap: ParentRatePlanMap = {};
  const ratePlans = rateGroup.ratePlans;

  // Iterate over each rate plan
  ratePlans.forEach((ratePlan) => {
    if (ratePlan.parentPerPersonRatePlan) {
      // If it has a parent, add it as a child to its parent rate plan
      const parentId = ratePlan.parentPerPersonRatePlan.id;
      if (parentId in parentRatePlansMap) {
        parentRatePlansMap[parentId].childRatePlans.push(ratePlan);
      } else {
        // If the parent doesn't exist yet, create it
        parentRatePlansMap[parentId] = {
          ...ratePlan.parentPerPersonRatePlan,
          childRatePlans: [ratePlan],
          rateGroup,
        };
      }
    } else {
      // If it doesn't have a parent, add it as a parent rate plan
      parentRatePlansMap[ratePlan.id] = {
        ...ratePlan,
        childRatePlans:
          parentRatePlansMap[ratePlan.id]?.childRatePlans?.length > 0
            ? parentRatePlansMap[ratePlan.id]?.childRatePlans
            : [], // Initialize empty array for child rate plans
        rateGroup,
      };
    }
  });

  // Convert the parent rate plans map to an array of RatePlanMerged
  return Object.values(parentRatePlansMap);
};
